import Axios from "../../../../api/axios/Axios";

export const getPopsFeed = async ({
  limit = 10,
  offset = 0,
  initialPopId = null,
  seed,
  signal,
} = {}) => {
  const response = await Axios.get("/api/feed/pops", {
    params: {
      limit,
      offset,
      seed,
      ...(initialPopId ? { initialPopId } : {}),
    },
    signal,
  });

  return response.data;
};
